<div class="card m-4">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Important details</div>
	</div>
	<p-divider></p-divider>
	<div *ngIf="!quoteService.quote.value.FocusCloudPlus__c">
		<div class="p-grid line-item-description">
			<div class="col-6 p-md-3">Equipment & Service Total</div>
			<div class="col-6 p-md-3">{{ quoteService.quote.value.TotalEquipmentProfessionalServices__c | currency }}</div>
			<div class="col-6 p-md-3">Payment Terms for Equipment</div>
			<div class="col-6 p-md-3">{{ quoteService.quote.value.DirectPurchasePaymentTerms__c }}</div>
		</div>
		<div class="p-grid line-item-description">
			<div class="col-6 p-md-3">Equipment Deposit Required</div>
			<div class="col-6 p-md-3">{{ quoteService.quote.value.DepositAmount__c | currency }}</div>
			<div class="col-6 p-md-3"></div>
			<div class="col-6 p-md-3"></div>
		</div>
	</div>

	<div
		class="p-grid line-item-description"
		*ngIf="quoteService.quote.value.TotalSubscription__c"
		[ngClass]="!quoteService.quote.value.FocusCloudPlus__c ? 'mt-4' : ''"
	>
		<div class="col-6 p-md-3">Subscription</div>
		<div class="col-6 p-md-3">
			<div *ngIf="!quoteService.quote.value.FocusCloudPlus__c">
				{{ quoteService.quote.value.TotalSubscription__c | currency }}
			</div>
			<div *ngIf="quoteService.quote.value.FocusCloudPlus__c">{{ quoteService.quote.value.FocusCloudPlusSubscription__c | currency }}<sup>1</sup></div>
		</div>
		<div class="col-6 p-md-3">Subscription Billing</div>
		<div class="col-6 p-md-3">{{ quoteService.quote.value.BillingFrequency2__c }}</div>
	</div>
	<div
		class="p-grid line-item-description"
		*ngIf="quoteService.quote.value.TotalSubscription__c && quoteService.quote.value.Contract_Term__c && quoteService.quote.value.Contract_Term__c > 1"
	>
		<div class="col-6 p-md-3">Contract Term</div>
		<div class="col-6 p-md-3">{{ quoteService.quote.value.Contract_Term__c }} months</div>
		<div class="col-6 p-md-3">Approx Contract Start Date</div>
		<div class="col-6 p-md-3">{{ app.moment(quoteService.quote.value.EstimatedStartDate__c, "YYYY-MM-DD").format("l") }}</div>
	</div>
	<ul class="item-detailed-description">
		<li>
			The <i>Contract Start Date</i> is an estimate. Your actual <i>Contract Start Date</i> with Focus will be the date that your Focus system is
			installed, unless otherwise noted and agreed to in writing by Focus.
		</li>
		<li>
			Our quotes do not include shipping, sales tax, travel expenses, tariffs, duty or government surcharges that may be imposed based on the source of
			the product or other factors outside of the control of Focus and since those amounts may change. We'll calculate shipping and final sales tax prior
			to delivery and add those amounts to your final invoice. Travel expenses, where applicable will be invoiced separately after implementation has been
			completed. Tariffs, duty or government surcharges may be passed on to you via a separate invoice when applicable. Sorry, we don't make those rules.
		</li>
		<li>
			Due to the current volitility of certain commodities this quote will expire on
			{{ app.moment(quoteService.quote.value.ExpirationDate).format("l") }}. We're happy to refresh it with the then-current costs.
		</li>
		<li>
			There may be some additional terms and conditions that apply to this quote. Please visit <a href="https://focusca.com/legal">our legal page</a> for
			more information.
		</li>
		<li>
			All purchases, purchase agreements, orders, subscriptions and services are governed by the Focus CA Master Subscription Agreement and corresponding
			use agreements available on <a href="https://focusca.com/legal">our legal page</a>. Your acceptance of this quote includes acceptance of the Master
			Subscription Agreement. Upon acceptance of this quote, your continued used of our product(s) implies your on-going consent to those agreements.
		</li>
		<li *ngIf="quoteService.quote.value.PaymentTermNotes__c">
			{{ quoteService.quote.value.PaymentTermNotes__c }}
		</li>
		<li *ngIf="quoteService.quote.value.FocusCloudPlus__c">
			<sup>1</sup> FocusCloud+ Subscription amounts are based on many factors, including time in business, credit rating and system size. Final
			subscription amount will be provided after the FocusCloud+ Application has been completed and processed. You may change your system order up until
			the point that the Final Subscription amount has been accepted.
		</li>
	</ul>
</div>
